// replace the value of the apiKey variable with your own API key
export const apiKey = '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';
